// replace the value of the apiKey variable with your own API key
export const apiKey = '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';
